import { ENDPOINTS } from 'config/endpoints';
import client from 'utils/clients/client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { ICreateList } from './useCreateList';

export interface IPatchList extends Omit<ICreateList, 'type'> {
  id: number;
}

export default function usePatchList() {
  const queryClient = useQueryClient();

  const patchList = (updatedList: IPatchList) => {
    const request: Request = {
      url: `${ENDPOINTS.list.main}`,
      config: {
        method: 'patch',
        data: { data: updatedList },
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<
    Response<null>,
    CronoError,
    IPatchList
  >(patchList, {
    onSettled: (_data, _errors, variables) => {
      queryClient.invalidateQueries([ENDPOINTS.list.search]);
      queryClient.invalidateQueries([ENDPOINTS.list.main, variables.id]);
    },
  });

  return { data, mutate, ...rest };
}
